"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("../../utils/underscore");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _Style = require("../../core/Style");

var getLabel = function getLabel(use) {
  if (use === 'decrease') return _I18n.default.text('salesUI.UIChangeArrow.decrease');
  if (use === 'increase') return _I18n.default.text('salesUI.UIChangeArrow.increase');
  return null;
};

var ChangeArrow = _styledComponents.default.svg.withConfig({
  displayName: "UIChangeArrow__ChangeArrow",
  componentId: "sc-1a3b3d3-0"
})(["font-size:16px;height:0.625em;margin-right:", ";width:0.875em;color:", ";transform:", ";"], (0, _Style.emCalc)(_sizes.BASE_ICON_SPACING_X), function (_ref) {
  var use = _ref.use;
  return use === 'increase' ? _colors.OZ : _colors.CANDY_APPLE;
}, function (_ref2) {
  var use = _ref2.use;
  return use === 'decrease' && 'rotate(180deg)';
});

var ChangeArrowShape = _styledComponents.default.path.withConfig({
  displayName: "UIChangeArrow__ChangeArrowShape",
  componentId: "sc-1a3b3d3-1"
})(["fill:currentColor;"]);

var UIChangeArrow = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIChangeArrow, _PureComponent);

  function UIChangeArrow(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIChangeArrow);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIChangeArrow).call(this, props));
    _this._id = (0, _underscore.uniqueId)('change-arrow-');
    return _this;
  }

  (0, _createClass2.default)(UIChangeArrow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          size = _this$props.size,
          style = _this$props.style,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["color", "size", "style", "use"]);
      return _react.default.createElement(ChangeArrow, Object.assign({}, rest, {
        "aria-labelledby": this._id,
        role: "img",
        style: Object.assign({
          color: color,
          fontSize: size
        }, style),
        use: use,
        viewBox: "0 0 14 10",
        xmlns: "http://www.w3.org/2000/svg"
      }), _react.default.createElement("title", {
        id: this._id
      }, getLabel(use)), _react.default.createElement(ChangeArrowShape, {
        d: "M0 9.63h14L7 0",
        fillRule: "evenodd"
      }));
    }
  }]);
  return UIChangeArrow;
}(_react.PureComponent);

UIChangeArrow.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.number,
  use: _propTypes.default.oneOf(['increase', 'decrease']).isRequired
};
UIChangeArrow.displayName = 'UIChangeArrow';
var _default = UIChangeArrow;
exports.default = _default;
module.exports = exports.default;